import React from 'react';
import ReactDOM from 'react-dom';
import {
  Overlay,
  Button,
  Popover,
} from 'react-bootstrap';
import $ from 'jquery';

export default class Alert extends React.Component {
  constructor(props) {
    super(props);
    this.closePopup = this.closePopup.bind(this);
    this.state = { show: props.show || false };
    this.alreadyShown = false;
  }
  componentWillReceiveProps(props) {
    if (props.data && (!this.alreadyShown || this.props.data != props.data)
      || (this.props.show != props.show && props.show)) {
      this.setState({ show: true });
      this.alreadyShown = false;
    } else {
      this.setState({ show: false });
    }
  }

  shouldComponentUpdate(nextProps, nextState) {
    if (nextState.show != this.state.show ||
       nextProps.data != this.props.data && (!nextProps || !this.props.data)) {
      return true;
    }
    return false;
  }

  closePopup(e) {
    e.stopPropagation();
    this.alreadyShown = true;
    this.setState({ show: false });
    if (this.props.hideAlert) {
      this.props.hideAlert();
    }
  }

  render() {
    let target;
    if (this.props.target !== undefined && $(`#${this.props.target}`)) {
      target = $(`#${this.props.target}`)[0];
    }
    return (<div>
      {target ?
        <Overlay
          show={this.state.show}
          target={() => ReactDOM.findDOMNode(target)}
          placement={this.props.placement ? this.props.placement : 'right'}
          container={target}
          containerPadding={20}
        >
          <Popover
            className={'popover-alert'}
            id="popover-positioned-scrolling-right"
          >
            <Button
              id="alertPopoverOkBtn"
              onClick={this.closePopup}
              className={'alert-popover-ok-btn'}
            >
              Ok
            </Button>
            <span
              id="alertPopoverText" className="alert-popover-text"
            >
              {this.props.data}
            </span>
          </Popover>
        </Overlay> : ''}
    </div>
    );
  }
}

Alert.propTypes = {
  message: React.PropTypes.string,
  show: React.PropTypes.bool,
  hideAlert: React.PropTypes.func,
  data: React.PropTypes.object,
  placement: React.PropTypes.string,
  target: React.PropTypes.string,
};
